import http from "./rsfhttpservices";

export async function getRsf(params) {
  let endPoint = "rsf";
  if (params) {
    endPoint += params;
  }

  const { data } = await http.get(endPoint);
  return data;
}

export async function settleTransaction(params) {
  let endPoint = "rsf/settle_transaction";

  const data = await http.post(endPoint, params);
  return data;
}

export async function getOrders() {
  let endPoint = "rsf/get_orders";

  const data = await http.post(endPoint);
  return data;
}

export async function getOrderById(params) {
  let endPoint = "rsf/get_order_by_id";

  const data = await http.post(endPoint, params);
  return data;
}

export async function getReconRequests() {
  let endPoint = "rsf/get_recon_requests";

  const data = await http.post(endPoint);
  return data;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getRsf,
  settleTransaction,
  getOrders,
  getOrderById,
  getReconRequests,
};
